<template>
    <product title="Hellast / Full load">
        <div slot="description">
            <p>
                P. Pedersen & Søn kan håndtere én eller flere afhentninger op til 38 tons pr. gang.
            </p>
            <p>
                <img style="width:400px;max-width:100%;" class="product-image" src="/static/images/fullload.jpg" />
            </p>
        </div>
    </product>
</template>
<script>
    import Product from '../../../components/elements/product'
    export default {
        name: 'Hellast',
        components: {
            'product': Product
        }
    }
</script>



// WEBPACK FOOTER //
// hellast.vue?60c9a3eb